import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default markers in React Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Component to handle map clicks
function LocationMarker({ position, setPosition }) {
  useMapEvents({
    click(e) {
      setPosition([e.latlng.lat, e.latlng.lng]);
    },
  });

  return position === null ? null : (
    <Marker position={position} />
  );
}

const MapSelector = ({ latitude, longitude, onLocationSelect, height = "300px" }) => {
  // Coordinates for Dakar, Senegal as default
  const defaultCenter = [14.7167, -17.4677];
  const [position, setPosition] = useState(null);

  useEffect(() => {
    if (latitude && longitude) {
      setPosition([parseFloat(latitude), parseFloat(longitude)]);
    } else {
      setPosition(defaultCenter);
    }
  }, [latitude, longitude]);

  const handlePositionChange = (newPosition) => {
    setPosition(newPosition);
    if (onLocationSelect) {
      onLocationSelect({
        latitude: newPosition[0],
        longitude: newPosition[1]
      });
    }
  };

  return (
    <div style={{ height, width: '100%' }}>
      <div className="mb-2 text-sm text-gray-600">
        Cliquez sur la carte pour sélectionner la localisation
      </div>
      <MapContainer
        center={position || defaultCenter}
        zoom={13}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker position={position} setPosition={handlePositionChange} />
      </MapContainer>
      {position && (
        <div className="mt-2 text-xs text-gray-500">
          Position sélectionnée: {position[0].toFixed(6)}, {position[1].toFixed(6)}
        </div>
      )}
    </div>
  );
};

export default MapSelector;